<template>
  <div
    class="sticky top-0 z-20"
    v-if="messageHeader !== null && messageHeader.type && messageHeader.msg && messageHeader.msg != '' && messageHeader.type != ''"
  >
    <transition
      enter-active-class="ease-out duration-300"
      enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      enter-to-class="opacity-100 translate-y-0 sm:scale-100"
      leave-active-class="ease-in duration-200"
      leave-class="opacity-100 translate-y-0 sm:scale-100"
      leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    >
      <div class="flex justify-center">
        <div
          class="absolute flex items-center justify-center
                    text-center text-base
                    p-5 mt-10 w-max max-w-3/4
                    border-2"
          :class="{'bg-green-300 border-green-600 border-opacity-25 text-green-600' : messageHeader.type === 'success',
                   'bg-amber-100 border-amber-600 border-opacity-25 text-amber-600' : messageHeader.type === 'warning',
                   'bg-pink-300 border-2 border-pink-600 border-opacity-25 text-pink-600' : messageHeader.type === 'error',
                   'bg-amber-100 border-2 border-amber-600 border-opacity-25 text-amber-600' : messageHeader.type === 'INPUT'
          }"
        >
          <div>
            <div class="flex items-baseline justify-center">
              <icon
                v-if="messageHeader.type === 'success'"
                name="checkmark-circle-2"
                class="inline-block mr-2"
              />
              <icon
                v-else-if="messageHeader.type === 'warning'"
                name="alert-circle"
                class="inline-block mr-2"
              />
              <icon
                v-else-if="messageHeader.type === 'error' || messageHeader.type == 'INPUT'"
                name="alert-circle"
                class="inline-block mr-2"
              />
              <div class="text-lg">
                {{ messageHeader.msg }}
              </div>
            </div>
            <div
              class="mt-5"
              v-if="messageHeader.type == 'INPUT'"
            >
              <button
                @click="cancel_nosave()"
                class="border-amber-600 border-opacity-25 text-amber-600 bg-amber-100 border-2 rounded-md
                        transform hover:scale-110 duration-300
                      text-base p-2 mr-4"
              >
                ANNULER
              </button>
              <button
                @click="quit_nosave()"
                class="bg-amber-600 text-amber-100 border-amber-100 border-opacity-25 border-2 rounded-md
                        transform hover:scale-110 duration-300
                      text-base p-2"
              >
                QUITTER
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Icon from './Icon';

export default {
  components: {Icon},
  props: {
    messageHeader: {
      type: [Object, String],
      default: null
    }
  },

  methods:{
    cancel_nosave(){
      this.$emit('cancel');
    },
    quit_nosave(){
      this.$emit('quit');
    }
  }
};
</script>

<style scoped>

</style>
